module.exports = __webpack_public_path__ + "images/icons_v2/channels-34f6cafe.svg";